firebird.factory('videoTestLayoutService', [
    '$rootScope',
    '$timeout',
    '$interval',
    '$window',
    'logService',
    'attendeeService',
    'socketService',
    'helperService',
    'configService',
    'videoGlobalService',
    function (
        $rootScope,
        $timeout,
        $interval,
        $window,
        logService,
        attendeeService,
        socketService,
        helperService,
        configService,
        videoGlobalService
    ) {
        var service = {
            initialize: initialize
        };

        var self;

        return service;

        function initialize(selfParam) {
            self = selfParam;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            // test layout related code.
            self.showTestLayout = showTestLayout;
            self.hideTestLayout = hideTestLayout;
            self.testLayoutParseParams = testLayoutParseParams;
            self.onTestLayoutAddVideo = onTestLayoutAddVideo;
            self.onTestLayoutRemoveVideo = onTestLayoutRemoveVideo;
            self.onTestLayoutAddVideoRandom = onTestLayoutAddVideoRandom;
            self.onTestLayoutRemoveVideoRandom = onTestLayoutRemoveVideoRandom;
            self.onTestLayoutToggleSelf = onTestLayoutToggleSelf;
            self.onTestLayoutToggleContent = onTestLayoutToggleContent;
            self.setTestImages = setTestImages;
            self.hasTestLayout = false;
            self.testLayoutTimer = null;
            self.testlayoutMyName = null;

            self.broadcastVideoFeedCountForTestLayout = broadcastVideoFeedCountForTestLayout;
        }

        // show test layout to test with various layout algorithms. Use the testlayout URL parameter.
        // examples: "12" for 12 landscape videos, "llLplplp" for 8 mix of landscape and portrait and one spotlight landscape,
        // "24,1,P" for 23 landscape with delay of 1s in adding each and additionally first item as spotlight portrait making total 24.
        function showTestLayout() {
            var config = self.testLayoutParseParams();
            if (!config) {
                return false;
            }

            if (self.testimages && self.testimages.number) {
                $('header#header').css('display', 'none');
                $('#videoroom-videos').attr('testlayout', 'number');
            } else if ($('#videoroom-videos').css('background') == 'white') {
                $('header#header').css('display', '');
                $('#videoroom-videos').removeAttr('testlayout');
            }

            var boxTypes = config.boxTypes;
            var delay = config.delay;
            var first_item = config.first_item;
            var portrait_percent = config.portrait_percent;
            var randomize = config.randomize;
            var pinned = config.pinned;
            var selfindex = config.selfindex;
            var testlayout = config.testlayout;
            var contentindex = config.contentindex;

            var items = [];
            var i;

            self.layoutPageData.pinned.splice(0, self.layoutPageData.pinned.length);
            for (i = 0; !isNaN(testlayout) && i < testlayout; ++i) {
                var item = { index: i, name: 'user-' + i };
                // if 2 or less, assume first is self, otherwise no self.
                // if selfindex is supplied use that instead.
                item.fid =
                    (selfindex === null && (i || testlayout > 2)) || (selfindex !== null && i !== selfindex)
                        ? ('' + i).padStart(3, 0)
                        : undefined;
                if (item.fid === undefined) {
                    item.name += ' You';
                    var fid0 = ('' + i).padStart(3, 0); // to keep as sortName
                    self.testlayoutMyName = fid0;
                }
                if (contentindex !== null && contentindex === i) {
                    item.content = true;
                    item.name = 'Presentation - ' + item.name;
                    item.fid = self.getScreenshareIdFromAttendantId(parseInt(item.fid));
                }
                items.push(item);
                if (pinned && i < pinned) {
                    self.layoutPageData.pinned.push(item.fid || '' + self.attendantId);
                }
            }
            if (randomize) {
                // shuffle items.
                for (i = items.length - 1; i > 0; --i) {
                    var j = Math.floor(Math.random() * (i + 1));
                    var x = items[i];
                    items[i] = items[j];
                    items[j] = x;
                }
            }
            //console.log(randomize, JSON.stringify(items));

            if (!delay) {
                // if no delay is needed
                var maxvideo = null;
                for (i = 0; items.length > 0; ++i) {
                    var item1 = items.shift();
                    var orientation = boxTypes && (boxTypes[i] == 'p' || boxTypes[i] == 'P') ? 'portrait' : undefined;
                    if (i == 0 && first_item && !boxTypes) {
                        orientation = first_item == 'P' ? 'portrait' : undefined;
                    } else if (!boxTypes) {
                        orientation = Math.random() * 100 < portrait_percent ? 'portrait' : undefined;
                    }

                    var div = self.onTestLayoutAddVideo(item1.fid, i, item1.name, orientation, item1.content);

                    if (boxTypes && (boxTypes[i] == 'P' || boxTypes[i] == 'L')) {
                        maxvideo = div;
                    }
                }
                if (maxvideo) {
                    self.maxvideo = maxvideo;
                    self.updateVideosLayout();
                }
            } else if (!isNaN(testlayout) && testlayout > 0) {
                // delay is added when adding each video
                i = 0;
                self.testLayoutTimer = $interval(function () {
                    if (!items.length) {
                        $interval.cancel(self.testLayoutTimer);
                        self.testLayoutTimer = null;
                        return;
                    }
                    var item = items.shift();
                    var i = item.index;
                    var orientation = boxTypes && (boxTypes[i] == 'p' || boxTypes[i] == 'P') ? 'portrait' : undefined;
                    if (i == 0 && first_item && !boxTypes) {
                        orientation = first_item == 'P' ? 'portrait' : undefined;
                    } else if (!boxTypes) {
                        orientation = Math.random() * 100 < portrait_percent ? 'portrait' : undefined;
                    }

                    var div = self.onTestLayoutAddVideo(item.fid, i, item.name, orientation, item.content);

                    if (boxTypes && (boxTypes[i] == 'P' || boxTypes[i] == 'L')) {
                        self.maxvideo = div;
                        self.updateVideosLayout();
                    }
                    if (i == 0 && first_item && !boxTypes) {
                        self.maxvideo = div;
                        self.updateVideosLayout();
                    }
                    i++;
                }, delay * 1000);
            }

            self.onFSConnectionComplete();
            $timeout(function () {
                // hacky way to hide the sidebar, and stop the audio status spinner.
                $('.audio-status-container > .audio-status > i')
                    .removeClass('zmdi-spinner')
                    .removeClass('zmdi-hc-spin');
                if ($('aside#sidebar-left').hasClass('toggled')) {
                    $('#sidebar-toggle-button').click();
                }
            }, 1000);

            return true;
        }

        // hide all the test layout videos.
        function hideTestLayout() {
            self.logLayout('hide testlayout');
            if (self.testLayoutTimer) {
                $interval.cancel(self.testLayoutTimer);
                self.testLayoutTimer = null;
            }
            $window.$('#videoroom-videos > div').remove();
            if (self.layoutPage) {
                self.resetLayoutPageData();
            }
            self.updateVideosLayout();
        }

        function testLayoutParseParams() {
            var testlayout = configService.getClientValue('testlayout');
            if (!testlayout) {
                return null;
            }

            self.testlayoutMyName = null;
            self.hasTestLayout = true; // set here also, since some decisions depend on this, instead of waiting for this function to return.

            var testimages = configService.getClientValue('testimages');
            if (testimages == 'number') {
                self.testimages = { number: true };
            } else if (testimages) {
                // TODO: sanitize URL before use.
                self.testimages = { url: testimages };
                var match = testimages.match(/\.(\d+)x(\d+)\.(\d+)\/?$/);
                if (match) {
                    self.testimages.width = match[1];
                    self.testimages.height = match[2];
                    self.testimages.count = match[3];
                }
            } else {
                self.testimages = null;
            }

            var boxTypes = null;
            var delay = 0;
            var first_item = null;
            var portrait_percent = 0;
            var randomize = false;
            var pinned = 0;
            var selfindex = null;
            var contentindex = null;

            if (testlayout.indexOf(',') >= 0) {
                var parts = testlayout.split(',');
                testlayout = parts[0];
                if (testlayout.indexOf(':') < 0) {
                    delay = parseFloat(parts[1]);
                    first_item = parts[2] || null;
                    portrait_percent = parseFloat(parts[3]) || 0;
                    randomize = parts[4] == 'R';
                    pinned = parseInt(parts[5]) || 0;
                    selfindex = parseInt(parts[6]);
                    if (isNaN(selfindex)) {
                        selfindex = null;
                    }
                    contentindex = parseInt(parts[8]);
                    if (isNaN(contentindex)) {
                        contentindex = null;
                    }
                } else {
                    testlayout = 12; // default when using "name:value,..."
                    parts.forEach(function (nv) {
                        var index1 = nv.indexOf(':');
                        if (index1 >= 0) {
                            var attr1 = nv.substring(0, index1);
                            var value1 = nv.substring(index1 + 1);
                            if (attr1 == 'count') {
                                testlayout = value1 || '0';
                            } else if (attr1 == 'delay') {
                                delay = parseFloat(value1) || 0;
                            } else if (attr1 == 'first') {
                                first_item = value1;
                            } else if (attr1 == 'portrait') {
                                portrait_percent = parseFloat(value1) || 0;
                            } else if (attr1 == 'randomize') {
                                randomize = value1 == 'true';
                            } else if (attr1 == 'pinned') {
                                pinned = parseInt(value1) || 0;
                            } else if (attr1 == 'selfindex') {
                                selfindex = parseInt(value1);
                                if (isNaN(selfindex)) {
                                    selfindex = null;
                                }
                            } else if (attr1 == 'contentindex') {
                                contentindex = parseInt(value1);
                                if (isNaN(contentindex)) {
                                    contentindex = null;
                                }
                            }
                        }
                    });
                }
            }

            if (testlayout.match(/^\d+$/)) {
                testlayout = parseInt(testlayout);
            } else {
                boxTypes = testlayout.split('');
                testlayout = boxTypes.length;
            }

            var config = {
                testlayout: testlayout,
                boxTypes: boxTypes,
                delay: delay,
                first_item: first_item,
                portrait_percent: portrait_percent,
                randomize: randomize,
                pinned: pinned,
                selfindex: selfindex,
                contentindex: contentindex
            };

            self.layoutMethod = configService.getValue('layoutMethod');

            // only for testlayout, allow layoutLock from url parameter.
            var layoutLock = configService.getValue('layoutLock');
            if (layoutLock && layoutLock != 'false') {
                if (layoutLock == 'true') {
                    layoutLock = 'locked';
                }
                self.layoutLock = layoutLock;
                $window.$('#videoroom-videos').attr('layoutlock', layoutLock == 'locked');
                var fakeHost = configService.getClientValue('fakeHost');
                self.isHost = !fakeHost || fakeHost == 'true' || fakeHost == self.attendantId; // fake as host.
                if (fakeHost && !self.isHost) {
                    // send fetch-videos-layout
                    logService.log('videoroomCtrl - sending fetch-videos-layout to ' + fakeHost);
                    socketService.send({
                        message: 'attendee-message',
                        data: { type: 'fetch-videos-layout', to: fakeHost }
                    });
                }
            }
            self.layoutObjectFit = configService.getValue('layoutObjectFit');
            if (self.layoutObjectFit) {
                $window.$('#videoroom-videos').attr('objectfit', self.layoutObjectFit);
            }
            self.layoutMove = configService.getValue('layoutMove') == 'true';
            self.layoutTrigger = configService.getValue('layoutTrigger');
            self.layoutResize = configService.getValue('layoutResize') == 'true';
            self.layoutPopout = configService.getClientValue('layoutPopout') == 'true';
            self.layoutPin = configService.getValue('layoutPin') == 'true';
            self.layoutPage = self.parseLayoutPage(configService.getValue('layoutPage'));
            self.layoutPageReuse.enabled =
                helperService.getEnvironment() === 'prod' ? true : configService.getValue('layoutPageReuse') == 'true';
            var layoutDebug = configService.getValue('layoutDebug');
            self.layoutDebug =
                layoutDebug == 'true' ? true : layoutDebug && layoutDebug != 'false' ? layoutDebug : false;
            self.videoLabels = configService.getClientValue('videoLabels');
            if (self.videoLabels) {
                $window.$('#videoroom-videos').attr('videoLabels', self.videoLabels);
            } else {
                $window.$('#videoroom-videos').removeAttr('videoLabels');
            }

            self.layoutOrder = configService.getValue('layoutOrder');
            if (self.layoutOrder == 'false') {
                self.layoutOrder = null;
            }

            var talkerLayout = configService.getClientValue('talkerLayout') || 'auto'; // default is auto
            self.talkerLayout = talkerLayout == 'none' ? null : talkerLayout;

            if (self.talkerLayout) {
                $window.$('#videoroom-videos').attr('talkerLayout', self.talkerLayout);
            }

            self.initMaxVideosSize();

            self.logLayout('testlayout config=' + JSON.stringify(config));
            return config;
        }

        function onTestLayoutAddVideo(fid, index, name, orientation, content) {
            self.logLayout(
                'testlayout add video fid=' + fid + ' index=' + index + ' name=' + name + ' orientation=' + orientation
            );
            var div = self.createVideoElement(true, null, fid, content ? true : undefined, orientation);
            $window.$(div).attr('displayname', name);
            $window
                .$(div)
                .append(
                    '<div class="testlayout"><span>' +
                        (self.testimages && self.testimages.number ? index : '') +
                        '</span></div>'
                );

            self.setTestImages(index, div);
            if (content) {
                self.setScreenDisplay(true);
            }

            self.broadcastVideoFeedCountForTestLayout();

            return div;
        }

        function onTestLayoutRemoveVideo(fid) {
            if (self.testvideos) {
                self.onTestvideosStopPlay(fid);
                return;
            }

            self.logLayout('testlayout remove video fid=' + fid);
            var data = self.layoutPageData;
            var item = data.videos[fid];
            self.removeVideoElement(fid);
            var hasContent = false;
            if (item && item.content) {
                for (var fid1 in data.videos) {
                    if (data.videos[fid1].content) {
                        hasContent = true;
                        break;
                    }
                }
                if (!hasContent) {
                    self.setScreenDisplay(false);
                }
            }

            self.broadcastVideoFeedCountForTestLayout();
        }

        function broadcastVideoFeedCountForTestLayout() {
            if (self.hasTestLayout) {
                $rootScope.$broadcast('video-feed-count', self.layoutPageData.videoCount);
            }
        }

        function onTestLayoutToggleSelf() {
            self.logLayout('testlayout toggle self');
            var div0 = $window.$('#videoroom-videos > div.local').get(0);
            if (div0) {
                // exists.
                self.onTestLayoutRemoveVideo(div0.getAttribute('user'));
            } else {
                // does not exist.
                var name = attendeeService.displayName;
                if (self.testlayoutMyName) {
                    var index = parseInt(self.testlayoutMyName);
                    name = 'user-' + index + ' You'; // consistent with showTestLayout
                }
                div0 = self.onTestLayoutAddVideo(undefined, 0, name);
            }
        }

        function onTestLayoutToggleContent() {
            self.logLayout('testlayout toggle content');
            var div0 = $window.$('#videoroom-videos > div.remote.screen').get(0);
            if (div0) {
                // exists.
                self.onTestLayoutRemoveVideo(div0.getAttribute('user'));
            } else {
                // does not exist.
                // pick a random existing user, and add presentation fid for that.
                var divs = [].slice.call($window.$('#videoroom-videos > div[user]'));
                var index = Math.floor(Math.random() * divs.length);
                var div1 = divs[Math.floor(Math.random() * divs.length)];
                var fid = div1.getAttribute('user');
                var cid = self.getScreenshareIdFromAttendantId(parseInt(fid));
                var name = 'Presentation - ' + div1.getAttribute('displayname');
                div0 = self.onTestLayoutAddVideo(cid, index, name, undefined, true);
            }
        }

        function onTestLayoutAddVideoRandom(count) {
            if (self.testvideos) {
                self.testvideos.count += count;
                self.onTestvideosStartPlay(count);
                return;
            }

            if (!self.hasTestLayout) {
                return;
            }

            for (var i = 0, j = 0; i < count && j < count * 100; ++j) {
                // do not try more than 100 times per count.
                // TODO: should use portrait percent
                var index = Math.floor(Math.random() * 1000); // id: 0-999
                var fid = ('' + index).padStart(3, 0);
                var exists = $window.$('#videoroom-videos > div[user="' + fid + '"]').length > 0;
                if (exists) {
                    continue;
                } else {
                    ++i;
                }
                var name = 'user-' + index;
                self.onTestLayoutAddVideo(fid, index, name);
            }
        }

        function onTestLayoutRemoveVideoRandom(count) {
            if (!self.hasTestLayout) {
                return;
            }
            var items = [].slice.call($window.$('#videoroom-videos > div[user]'));
            var remove = [];
            for (var i = 0; i < count; ++i) {
                var index = Math.floor(Math.random() * items.length);
                var fid = items[index].getAttribute('user');
                items.splice(index, 1);
                remove.push(fid);
            }
            remove.forEach(function (fid) {
                self.onTestLayoutRemoveVideo(fid);
            });
        }

        function setTestImages(index, div) {
            if (self.testimages && self.testimages.url) {
                var tl = div.querySelector('div.testlayout');
                if (self.testimages.count) {
                    index = index % self.testimages.count;
                }
                tl.style.backgroundImage = 'url(' + self.testimages.url + '/' + index + '.jpg)';
                self.logLayout('setting background ' + tl.style.backgroundImage);
            }
        }
    }
]);
